import { defineMessages } from 'react-intl';

export default defineMessages({
  success: {
    id: 'graphql.linking-github-button.success',
    defaultMessage: 'You successfully linked your account with Github',
  },
});



// WEBPACK FOOTER //
// ./src/ui/graphql/LinkGithubButton/messages.js